import {
  B2BUser,
  DeliveryMode,
  Order,
  OrderEntry,
  OrderHistory,
  OrderHistoryList,
  PaymentDetails,
} from '@spartacus/core';
import { OrderUserProfileFilter } from '../enums';

export enum PaymentStatus {
  NotPaid = 'NOTPAID',
  PartPaid = 'PARTPAID',
  Paid = 'PAID',
  Pending = 'PENDING',
}
export interface CustomOrderHistory extends OrderHistory {
  code: string;
  paymentMode: string;
  paymentStatus?: PaymentStatus;
  deliveryMode: DeliveryMode;
  isB2BOrder?: boolean;
  storeUntilDateInfo?: string;
  entries?: OrderEntry[];
  showOrderNumberQrCode: boolean;
}

export interface CustomOrderHistoryList extends OrderHistoryList {
  orders?: CustomOrderHistory[];
}

export interface CustomPaymentDetails extends PaymentDetails {
  paymentMode?: string;
}

export interface CustomB2BUser extends B2BUser {
  email?: string;
}

class CustomOrderState {
  dateFormattedValue?: string;
  posStoragePeriodInfo?: string;
  status?: string;
  onlinePayment?: boolean;
}

export interface CustomOrder extends Order {
  orgCustomer?: CustomB2BUser;
  paymentMode?: string;
  paymentInfo?: CustomPaymentDetails;
  comment?: string;
  isOfflineOrder?: boolean;
  discountCard?: string;
  paymentRedirectURL?: string;
  paymentStatus?: PaymentStatus;
  paymentStatusInfo?: PaymentStatusInfo;
  pickupScheme?: string;
  pickupAddress?: string;
  deliveryMode?: CustomDeliveryMode;
  isB2BOrder?: boolean;
  orderState?: CustomOrderState;
  orderReceiveDate?: {
    dateFormattedValue: string;
    text: string;
  };
  /**
   * Схема склада
   */
  scheme?: string;
  bonus?: BonusInfo;
}

export interface BonusInfo {
  applyingAmountInfo: {
    formattedValue: string;
    value: number;
  };
  assignedAmountInfo: {
    formattedValue: string;
    value: number;
  };
}

export interface PaymentStatusInfo {
  code: PaymentStatus;
  name: string;
}

export interface CustomDeliveryMode extends DeliveryMode {
  scheme?: string;
  address?: string;
  completionDate?: string;
}

export interface RepeatOrderParams {
  cartId: string;
  orderCode: string;
}

export interface RepeatOfflineOrderParams {
  cartId: string;
  offlineOrderCode: string;
}

export interface OnlineOrderLoadListParams {
  pageSize: number;
  orderType: OrderUserProfileFilter;
  currentPage?: number;
  sort?: string;
}

export interface OfflineOrderLoadListParams {
  pageSize: number;
  currentPage?: number;
  sort?: string;
}
